import BpkHorizontalNav, {
  BpkHorizontalNavItem,
} from '@skyscanner-internal/backpack-web/bpk-component-horizontal-nav';

import withErrorBoundary from '../ErrorBoundary';

import type { SiteMapNavigationProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './SitemapNavigation.module.scss';

const SitemapNavigation = ({
  activePageType,
  pageTypes,
}: SiteMapNavigationProps) => (
  <BpkHorizontalNav className={STYLES.SitemapNavigation} autoScrollToSelected>
    {pageTypes
      ? pageTypes.map((pageTypeItem) => (
          <BpkHorizontalNavItem
            key={pageTypeItem.pageType}
            name={pageTypeItem.pageTitle}
            selected={activePageType === pageTypeItem.pageType}
            href={pageTypeItem.url}
          >
            {pageTypeItem.pageTitle}
          </BpkHorizontalNavItem>
        ))
      : null}
  </BpkHorizontalNav>
);

const SitemapNavigationWithErrorBoundary = withErrorBoundary(
  SitemapNavigation,
  'sitemap-navigation-component',
);
export default SitemapNavigationWithErrorBoundary;
